export default __webpack_public_path__ + "static/media/A8.29a3eaee.png";